import classNames from 'classnames';
import { useMemo } from 'react';
import { useCmsClientContext } from '../../../../utils/cmsPageContext';
import { getClientTranslations } from '../../../../utils/translations/getClientTranslations';
import { tr } from '../../../../utils/translations/tr';
import CheckIcon from '../../../icons/Check';
import WarningIcon from '../../../icons/Warning';
import { TRANSLATIONS } from '../../i18n';
import { ApprovalOddsValidityProps } from './types';

export const ApprovalOddsValidity = ({ isOutdated }: ApprovalOddsValidityProps) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(TRANSLATIONS, context);
  const classes = useMemo(() => {
    if (isOutdated) {
      return {
        bg: 'bg-highlights/red-light',
        text: 'text-colors/supplementary-red-dark'
      } 
    } else {
      return {
        bg: 'bg-fill/primary-light items-center',
        text: 'text-text/accent'
      } 
    }
  }, [isOutdated])
    
  return (
    <div
      className={classNames('flex flex-row gap-spacing/gap/soft-8px rounded-radius/card-inner p-spacing/gap/y', classes.bg)}
    >
      <div className={classes.text}>
      {isOutdated ? <WarningIcon /> :  <CheckIcon />}
      </div>
      <div
        className={classNames('flex flex-col gap-spacing/gap/soft-8px')}
      >
        <div className={classNames('mhg-alpha-typography-title-2', classes.text)}>
        {isOutdated ? tr('outdated_data_alert', staticText) :  tr('updated_data_reminder', staticText)}
        </div>
        {isOutdated && (
        <div className="mhg-alpha-typography-body-2">
          {tr('outdated_state_explanation', staticText)}
        </div>
      )}
      </div>
    </div>
  );
};
